import React from 'react';
import * as styles from './navPopup.module.css';
import { NavContext } from './NavContext';
import { FaCaretRight } from 'react-icons/fa';
import { IoMdGlobe } from 'react-icons/io';

class NavItem2 extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        if (this.context.selected === this.props.name) {
            this.props.togglePopup(null);
        } else {
            this.props.togglePopup(this.props.name);
        }
    }

    render() {
        if (!this.props.caret) {
            return (
                <a
                    id={this.props.id}
                    className="tw-inline-flex tw-items-center tw-uppercase tw-text-black tw-outline-0
                        tw-transition-colors tw-duration-300"
                    href={this.props.href}
                    target={this.props.target || ""}
                    rel="noopener noreferrer"
                >
                    {this.props.name}
                </a>
            );
        }

        let isSelected = this.context.isPopupOpen && this.context.selected === this.props.name;
        let rotate = isSelected ? styles.rotate : '';
        let icon =
            this.props.name === 'Language' ? (
                <span className="tw-ml-1 tw-text-xl">
                    <IoMdGlobe />
                </span>
            ) : (
                <span className={`${styles.caret} ${rotate}`}>
                    <FaCaretRight />
                </span>
            );

        return (
            <button
                id={this.props.id}
                onClick={this.toggle}
                data-selected={isSelected}
                className="tw-inline-flex tw-items-center tw-uppercase tw-text-black tw-outline-0 tw-transition-colors
                    tw-duration-300 data-[selected=true]:tw-text-brand"
            >
                {this.props.intName}
                {icon}
            </button>
        );
    }
}

NavItem2.contextType = NavContext;

export default NavItem2;
